import { IntegrationServiceId } from '../../../common/integrations'
import React from 'react'
import { getIntegrationColor } from '../integrationColors'
import { ReactComponent as ZocksIcon } from '../../../assets/ZocksLogo.svg'
import { IntegrationIcon } from '../../IntegrationIcon'
import './RectangleIntegrationIcon.scss'

const IntegrationOrZocksIcon: React.FC<{ serviceId: IntegrationServiceId | 'Zocks' }> = ({ serviceId }) => {
  if (serviceId === 'Zocks') {
    return <ZocksIcon />
  }
  return <IntegrationIcon serviceId={serviceId} className={'zocks-p-0.625 w-8 h-8'} fill={'white'} />
}

interface RectangleIntegrationIconProps {
  serviceId: IntegrationServiceId | 'Zocks'
}

export const RectangleIntegrationIcon: React.FC<RectangleIntegrationIconProps> = ({ serviceId }) => {
  const integrationColor = getIntegrationColor(serviceId)

  return (
    <div className='rectangle-integration-icon' style={{ backgroundColor: integrationColor }}>
      <IntegrationOrZocksIcon serviceId={serviceId} />
    </div>
  )
}
